import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './RequestSupplierReorderModal.module.scss';
import { useDispatch } from 'react-redux';
import { sendRequestReorderEmailFromSupplier } from '../../../store/actions/supplierReorderPermissions';
import cn from 'classnames';

function RequestSupplierReorderModal(props) {
  const { onClose, isOpen, wasEmailSent } = props;
  const dispatch = useDispatch();

  const modalContent = useMemo(
    () =>
      wasEmailSent ? (
        <>
          <h2>Start selling through reorders!</h2>
          <hr />
          <div className={styles.requestReorderBody}>
            We got your request, our team will contact you within 2 business days,
          </div>
          <hr />
          <div className={cn(styles.footer, styles.emailSent)}>
            <Button color="white" text="Close" onClick={onClose} />
          </div>
        </>
      ) : (
        <>
          <h2>Start selling with Reorders!</h2>
          <hr />
          <div className={styles.requestReorderBody}>
            Our Reorder feature, enables your independent retail and boutique partners to place orders directly in our
            app.
            <br />
            Creating new opportunities and increasing sales with no hassle! Click "Learn more" and our experts will set
            time to speak more about how you can increase your independent buys!
          </div>
          <hr />
          <div className={styles.footer}>
            <Button text="Learn more" onClick={() => dispatch(sendRequestReorderEmailFromSupplier())} />
            <Button color="white" text="Not interested" onClick={onClose} />
          </div>
        </>
      ),
    [dispatch, onClose, wasEmailSent],
  );

  return (
    <ModalWindow open={isOpen} onClose={onClose}>
      {modalContent}
    </ModalWindow>
  );
}

export default RequestSupplierReorderModal;

RequestSupplierReorderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  wasEmailSent: PropTypes.bool,
};
